<script>
import { get } from 'lodash';
import SmallCardAbstract from './small-card-abstract';

export default {
  name: 'program-diet-small-card',
  mixins: [
    SmallCardAbstract,
  ],
  props: {
    icon: {
      required: false,
      default: 'fal fa-calendar-alt',
    },
    theme: {
      required: false,
      default: 'diet',
    },
  },
  computed: {
    picture() {
      const dir = process.env.IMAGES_ROOT;
      const path = get(this.details, 'CoverImage', false);
      const filename = get(this.image, 'thumbnails.large.filename', false);
      return dir && path && filename ? `${dir}${path}${filename}` : null;
    },
    name() {
      return get(this.details, 'data.name', null);
    },
    description() {
      return get(this.details, 'data.description', null);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/card/program-diet-small-card.vue